import React from 'react'

export default class IconsMainNavGettingStarted extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M10.022 6.29339C10.0875 6.33127 10.1419 6.38571 10.1796 6.45124C10.2174 6.51676 10.2373 6.59108 10.2373 6.66672C10.2373 6.74236 10.2174 6.81667 10.1796 6.8822C10.1419 6.94773 10.0875 7.00217 10.022 7.04005L7.31202 8.60805C7.24658 8.64592 7.1723 8.66585 7.09669 8.66586C7.02108 8.66586 6.94681 8.64592 6.88136 8.60806C6.81592 8.5702 6.76161 8.51575 6.72392 8.4502C6.68623 8.38465 6.66649 8.31033 6.66669 8.23472V5.09872C6.66656 5.02321 6.68631 4.94899 6.72397 4.88354C6.76162 4.81809 6.81585 4.7637 6.8812 4.72586C6.94654 4.68802 7.0207 4.66805 7.09621 4.66797C7.17172 4.66789 7.24593 4.68769 7.31136 4.72539L10.022 6.29339Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.66669 14H11.3334'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M13.3333 2H2.66665C1.93027 2 1.33331 2.59695 1.33331 3.33333V10C1.33331 10.7364 1.93027 11.3333 2.66665 11.3333H13.3333C14.0697 11.3333 14.6666 10.7364 14.6666 10V3.33333C14.6666 2.59695 14.0697 2 13.3333 2Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
